/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 15/02/22
 */

import { Avatar, HStack, Text, VStack } from '@chakra-ui/react';
import React from 'react';

interface UserDetailsProps {
    name: string;
    id: string;
}

const UserDetails = ({ name, id }: UserDetailsProps) => (
    <HStack spacing={4}>
        <Avatar name={name} size="lg" />
        <VStack alignItems="flex-start" spacing={0}>
            <Text>{name}</Text>
            <Text>{id}</Text>
        </VStack>
    </HStack>
);

export default UserDetails;
